import { render } from "./UsefulPhoneNumbersPage.vue?vue&type=template&id=3cc4b21f"
import script from "./UsefulPhoneNumbersPage.vue?vue&type=script&lang=js"
export * from "./UsefulPhoneNumbersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__